import { SxProps, Theme } from '@mui/material';
import {
  getDropdownOptionStyles,
  getDropdownSurfaceActiveBackground,
} from '@onevision-resources/design-theme';

/** One row look for both lists of the Display dialog: the visible attributes and the catalog. */
export const attributeRowSx: SxProps<Theme> = (theme) => ({
  ...getDropdownOptionStyles(),
  display: 'flex',
  alignItems: 'center',
  cursor: 'default',
  // A tap leaves :hover stuck on touch screens, so the tint is for a real pointer only.
  '@media (hover: hover)': {
    '&:hover': { backgroundColor: getDropdownSurfaceActiveBackground(theme) },
  },
});

/** The checkbox and its name: the part of a row that toggles the attribute. */
export const attributeToggleSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: getDropdownOptionStyles().gap,
  flex: 1,
  minWidth: 0,
  cursor: 'pointer',
};

const handleFocusRingSx: SxProps<Theme> = {
  '&:focus-visible': {
    outline: (theme) => `2px solid ${theme.palette.custom.OV.sys.primary}`,
    outlineOffset: '1px',
  },
};

export const getDesktopGripSx = (isDragging: boolean): SxProps<Theme> => ({
  display: 'grid',
  placeItems: 'center',
  width: '1rem',
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
  cursor: isDragging ? 'grabbing' : 'grab',
  touchAction: 'none',
  borderRadius: '0.25rem',
  ...handleFocusRingSx,
});

export const touchHandleSx: SxProps<Theme> = {
  width: '2rem',
  height: '2rem',
  borderRadius: '0.5rem',
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
  touchAction: 'none',
  '&:hover': {
    backgroundColor: (theme) => theme.palette.custom.OV.sys.surfaceContainerHigh,
    color: (theme) => theme.palette.custom.OV.sys.onBackground,
  },
  ...handleFocusRingSx,
};

export const liveRegionSx: SxProps<Theme> = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
};
